module.exports = __webpack_public_path__ + "img/case22.c37fdc81.png";